import LogoutAlias from "./LogoutAlias"
export default LogoutAlias
